
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consent",
      function () {
        return require("private-next-pages/consent.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consent"])
      });
    }
  